import React from "react";
import { api } from "../../lib/api";
import { Database, Crown, Users, CurrencyEur } from "@phosphor-icons/react";
import ErrorAlertBanner from "../ErrorAlertBanner";
import { StatCard } from "./panels-shared";
import InsightsWidgets from "./InsightsWidgets";
import ProspectQualityWidget from "./ProspectQualityWidget";
import ProspectHandoffPanel from "./ProspectHandoffPanel";

export default function OverviewPanel({ data, teleproNewCount, teleproLatest, onGoToTelepro, onGoToSearchMisses, onReload }) {
  return (
    <>
      {data.new_users?.count > 0 && (
        <div className="bg-primary/10 border-l-4 border-primary rounded-sm p-4 mb-6 flex items-start gap-3" data-testid="new-clients-alert">
          <div className="text-2xl shrink-0">🎉</div>
          <div className="flex-1 min-w-0">
            <div className="font-display font-semibold text-base text-primary mb-1">
              {data.new_users.count} nouvel{data.new_users.count > 1 ? "·le·s client·e·s inscrit·e·s" : " client·e inscrit·e"} depuis ta dernière visite
            </div>
            <ul className="text-xs text-foreground/80 space-y-0.5">
              {data.new_users.latest.map((u, i) => (
                <li key={i}>
                  <b>{u.first_name} {u.last_name}</b> — {u.email}
                  {u.business_name ? <> · {u.business_name}</> : null}
                  {u.telepro_code ? <> · <span className="text-secondary">via {u.telepro_code}</span></> : null}
                </li>
              ))}
            </ul>
          </div>
          <button
            onClick={async () => {
              await api.post("/admin/new-users/mark-seen");
              onReload?.();
            }}
            className="bg-primary text-primary-foreground hover:bg-[#0f3d29] hover:text-white text-xs font-semibold px-3 py-2 rounded-sm shrink-0"
            data-testid="new-clients-mark-seen"
          >
            Marquer comme vu
          </button>
        </div>
      )}
      {teleproNewCount > 0 && (
        <div className="bg-secondary/10 border-l-4 border-secondary rounded-sm p-4 mb-6 flex items-start gap-3" data-testid="new-telepro-alert">
          <div className="text-2xl shrink-0">📞</div>
          <div className="flex-1 min-w-0">
            <div className="font-display font-semibold text-base text-secondary mb-1">
              {teleproNewCount} nouvel{teleproNewCount > 1 ? "s téléprospecteurs/trices inscrit·e·s" : " téléprospecteur·trice inscrit·e"} depuis ta dernière visite
            </div>
            <ul className="text-xs text-foreground/80 space-y-0.5">
              {teleproLatest.slice(0, 5).map((tp) => (
                <li key={tp.code}>
                  <b>{tp.code}</b> — {tp.first_name} {tp.last_name} ({tp.email})
                </li>
              ))}
            </ul>
          </div>
          <button
            onClick={onGoToTelepro}
            className="bg-secondary text-secondary-foreground hover:bg-[#a35d42] text-xs font-semibold px-3 py-2 rounded-sm shrink-0"
            data-testid="new-telepro-alert-cta"
          >
            Voir →
          </button>
        </div>
      )}
      <ErrorAlertBanner />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-testid="admin-overview">
        <StatCard icon={<Database size={20}/>} label="Entreprises" value={data.businesses.toLocaleString("fr")}/>
        <StatCard icon={<Crown size={20}/>} label="Premium" value={data.premium_businesses}/>
        <StatCard icon={<Users size={20}/>} label="Utilisateurs" value={data.users}/>
        <StatCard icon={<CurrencyEur size={20}/>} label="Revenu mensuel (MRR)" value={`${data.mrr_eur} €`}/>
      </div>
      <InsightsWidgets onGoToSearchMisses={onGoToSearchMisses}/>
      <ProspectQualityWidget/>
      <ProspectHandoffPanel/>
    </>
  );
}
